import { asArray } from './as-array';
export const addOrReplace = <T>(key: string, entities: T[], replace: T | T[]): Array<T> =>
	entities.map((d) => asArray(replace).find((q) => q[key] === d[key]) || d);
